import React from "react";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import { useUserValidation } from "../../Components/Validation/useUser_Validation";
import { useToast } from "../../Hooks/useToast";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import FromikTextField from "../../Components/Utils/Formik_Texfiled";
import CustomButton from "../../Components/Utils/Custom_Btn";

import { FetchCreateUser } from "../../Apis/Users/Create_User";


const CreatUser = () => {
  const navigate = useNavigate();
  const { formValidation } = useUserValidation();
  const { toastSuccess, toastError } = useToast();

  const formik = useFormik({
    initialValues: {
      firstName: "", 
      lastName: "",
      email: "",
      address:"",
      phoneNumber:"",
      password: "",
      passwordConfirm: "",
    },
    validationSchema: formValidation,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        const result = await FetchCreateUser(values);
    
        if (result && result.status === 201) {
          toastSuccess("Kunde erfolgreich erstellt!");
          navigate("/Kunden");
        } else {
          toastError("Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.");
          setFieldError("email", "Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.");
        }
      } catch (error) {
        console.error("Fehler beim Erstellen des Kunden:", error);
        toastError("Ein Fehler ist aufgetreten.");
        setFieldError("email", "Ein Fehler ist aufgetreten.");
      } finally {
        setSubmitting(false);
      }
    }
    
  });

  return (
    <Box ml={2} >
      <AlternativeHeader
        onPrevious={() => navigate("/Kunden")}
        title="Fügen Sie einen Kunden hinzu"
      />

      <Box mt={6}>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="firstName"
              label="Vorname"
              placeholder="Vorname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="lastName"
              label="Nachname"
              placeholder="Nachname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="email"
              label="E-Mail"
              placeholder="beispiel@email.com"
              type="email"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="phoneNumber"
              label="Telefonnummer"
              placeholder="33124432"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="address"
              label="Adresse"
              placeholder="Adresse"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="password"
              label="Passwort"
              placeholder="Passwort"
              type="password"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FromikTextField
              formik={formik}
              name="passwordConfirm"
              label="Passwort bestätigen"
              placeholder="Passwort bestätigen"
              type="password"
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mt: 4, bgcolor: "#000000" }} />

      <Box mt={2} display="flex" justifyContent="flex-end">
        <CustomButton
          onNavigate={formik.handleSubmit}
          title="speichern"
        />
      </Box>
    </Box>
  );
};

export default CreatUser;
